var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaLibraryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Media_Library_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media_Library_Active",
    "data-name": "Media Library_Active",
    clipPath: "url(#clip-Media_Library_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media_Library",
    "data-name": "Media Library",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_66",
    "data-name": "Subtraction 66",
    d: "M-901.647-771.294a14.259,14.259,0,0,1-10.149-4.2,14.259,14.259,0,0,1-4.2-10.149,14.259,14.259,0,0,1,4.2-10.149,14.259,14.259,0,0,1,10.149-4.2,14.259,14.259,0,0,1,10.149,4.2,14.259,14.259,0,0,1,4.2,10.149,14.259,14.259,0,0,1-4.2,10.149A14.259,14.259,0,0,1-901.647-771.294Zm-2.452-20.766a2.486,2.486,0,0,0-1.229.33,2.479,2.479,0,0,0-1.265,2.174v7.834a2.476,2.476,0,0,0,1.265,2.173,2.593,2.593,0,0,0,1.232.325v-.016h.007a2.443,2.443,0,0,0,1.275-.356l6.568-3.908a2.472,2.472,0,0,0,1.216-2.141,2.472,2.472,0,0,0-1.216-2.141l-6.568-3.909A2.489,2.489,0,0,0-904.1-792.059Z",
    transform: "translate(916.649 800.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    d: "M21.752,36.753a15,15,0,1,1,15-15,14.719,14.719,0,0,1-1.314,6.13.65.65,0,0,1-1.184-.535,13.556,13.556,0,0,0,1.2-5.6,13.7,13.7,0,1,0-4.428,10.088.654.654,0,0,1,.892.957,14.934,14.934,0,0,1-10.169,3.957Z",
    transform: "translate(-6.75 -6.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    d: "M23.3,22.5a.623.623,0,0,1-.405-.146.663.663,0,0,1-.1-.924,2.678,2.678,0,0,0,.259-.357c.032-.049.081-.13.146-.227a.654.654,0,1,1,1.087.73,1.986,1.986,0,0,0-.13.195c-.1.146-.162.227-.341.454a.653.653,0,0,1-.5.243Z",
    transform: "translate(3.137 1.84)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibraryActive);
export default __webpack_public_path__ + "static/media/Media_Library_Active.9c728701a86a9f84c04b83027f83f401.svg";
export { ForwardRef as ReactComponent };